module.exports = __webpack_public_path__ + "media/replace_bg.368fe92a.mp4";